/**
 * Lectura de claims del access token.
 * Solo decodifica el payload, no valida la firma: sirve para decisiones de la interfaz,
 * nunca para autorizar. La autorización la hace el backend
 */

export const CLAIM_ID_REL_USUARIO_ENTIDADES = 'IdRelUsuarioEntidades';
export const CLAIM_ID_ENTIDAD = 'IdEntidad';

const leerPayloadToken = (token: unknown): Record<string, unknown> | null => {
  if (typeof token !== 'string') return null;

  const partes = token.split('.');
  if (partes.length !== 3) return null;

  try {
    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    const conRelleno = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const bytes = Uint8Array.from(atob(conRelleno), (caracter) => caracter.charCodeAt(0));
    const payload = JSON.parse(new TextDecoder().decode(bytes));

    return payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : null;
  } catch {
    return null;
  }
};

/**
 * Valor de un claim del token, sin distinguir mayúsculas.
 * Devuelve `null` si el token no se puede leer o si el claim no viene, está vacío o es `0`
 */
export const obtenerClaimToken = (token: unknown, claim: string): string | null => {
  const payload = leerPayloadToken(token);
  if (!payload) return null;

  const clave = Object.keys(payload).find((nombre) => nombre.toLowerCase() === claim.toLowerCase());
  if (!clave) return null;

  const valor = payload[clave];
  const texto = String((Array.isArray(valor) ? valor[0] : valor) ?? '').trim();

  return texto === '' || texto === '0' ? null : texto;
};

/** El token trae una relación usuario-entidad (claims `IdRelUsuarioEntidades` o `IdEntidad`) */
export const tokenTieneEntidad = (token: unknown): boolean =>
  obtenerClaimToken(token, CLAIM_ID_REL_USUARIO_ENTIDADES) !== null ||
  obtenerClaimToken(token, CLAIM_ID_ENTIDAD) !== null;
